import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { PosStoreService } from '../../pos.store.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';

@Component({
  selector: 'app-sales-order-scan-stock-code-dialog',
  templateUrl: './sales-order-scan-stock-code-dialog.component.html',
  styleUrls: ['./sales-order-scan-stock-code-dialog.component.scss']
})
export class SalesOrderScanStockCodeDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('scanInput') scanInput;

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderScanStockCodeDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private posStoreService: PosStoreService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
  ) {
    this.form = fb.group({
      stockCode: ['', Validators.compose([Validators.required])],
      qty: [1, Validators.compose([Validators.required, Validators.min(1)])]
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scanInput.nativeElement.focus();
    }, 0)
  }

  search() {
    if (this.data.mode === 'SYSPRO') {
      const dialogData: OiGroupDialogData = {
        title: 'Adding line to the order in SYSPRO',
        function: 'portal_oi_group_syspro_order_add_line',
        postBody: {
          salesOrderNumber: this.data.salesOrderNumber,
          stockCode: this.form.value.stockCode,
          qty: this.form.value.qty
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('Line Added');
        } else {
          setTimeout(() => {
            this.scanInput.nativeElement.select();
          }, 0);
        }
      });

    } else {
      this.baseService.executeCommand<any[]>('portal_sales_order_add_stock_code', {
        salesOrderHeaderId: this.data.salesOrderHeaderId,
        stockCode: this.form.value.stockCode,
        qty: this.form.value.qty
      })
        .subscribe(response => {
          if (response.responseCode === 0) {

            this.form.controls['stockCode'].reset();
            this.form.controls['qty'].setValue(1);

            this.posStoreService.notifySalesOrderChanged({
              salesOrderHeaderId: this.data.salesOrderHeaderId,
              source: 'SalesOrderScanStockCodeDialogComponent'
            });

            setTimeout(() => {
              this.scanInput.nativeElement.focus();
            }, 0)
          } else {
            setTimeout(() => {
              this.scanInput.nativeElement.select();
            }, 0);
          }
        });
    }
  }

}
